<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<h2 class="sub_title">
						{{ $t('rtr_personal-how-offline_kiosk.title1') }}<br />
						{{ $t('rtr_personal-how-offline_kiosk.title2') }}
					</h2>
					<p class="sub_text">
						{{ $t('rtr_personal-how-offline_kiosk.text1') }}<br />{{
							$t('rtr_personal-how-offline_kiosk.text2')
						}}<br />{{ $t('rtr_personal-how-offline_kiosk.text3') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_black"
							@click="$router.push({ name: 'auth-login' })"
						>
							{{ $t('auth.login_btn') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_content1">
				<p class="catch_text">
					<span>{{ $t('rtr_personal-how-offline_kiosk.text4') }}</span
					>{{ $t('rtr_personal-how-offline_kiosk.text5') }}
				</p>
				<div class="section01 pt_30">
					<div class="d_flex justify_center">
						<div class="area">
							<div class="circle cr_1">
								<img
									src="@/assets/images/sub/offline_kiosk_icon_01.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-offline_kiosk.text6') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text7') }}
							</p>
						</div>
						<div class="area base">
							<span class="arrow"></span>
						</div>
						<div class="area">
							<div class="circle cr_2">
								<img
									src="@/assets/images/sub/offline_kiosk_icon_02.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-offline_kiosk.text8') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text9') }}
							</p>
						</div>
						<div class="area base">
							<span class="arrow"></span>
						</div>
						<div class="area">
							<div class="circle cr_3">
								<img
									src="@/assets/images/sub/offline_kiosk_icon_03.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-offline_kiosk.text10') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text11') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content2">
				<p class="catch_text">
					{{ $t('rtr_personal-how-offline_kiosk.text12')
					}}{{ $t('rtr_personal-how-offline_kiosk.text13') }}
				</p>
				<div class="section01">
					<div class="d_flex justify_center">
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/offline_kiosk_rectangle_01.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-offline_kiosk.text14') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-offline_kiosk.text15') }}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/offline_kiosk_rectangle_02.png"
										alt=""
										class="mb_20 w_89"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-offline_kiosk.text16') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-offline_kiosk.text17') }}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/offline_kiosk_rectangle_03.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-how-offline_kiosk.text18') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-how-offline_kiosk.text19') }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_personal-how-offline_kiosk.title3') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.title4') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-how-offline_kiosk.text20') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text21') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/offline_kiosk_02.png" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'OfflineKiosk',
};
</script>

<style scoped></style>
